define("Pages/Promoter", [`Page`, `module`], (Super, Self) => {
	const SCROLL_BUFFER_HEIGHT = 30; // used to fetch new events before the scroll hits the end
	const EVENTS_PER_PAGE = 20; // used for deciding if a response is the last set

	return Super.inherit({
		namespace: Self.id,
		requires: [`Promoters`, `XHR`],
		defaults: {
			render: true,
		},
		prepare(setup) {
			const pageUrl = window.location.href;
			const { Promoters, data } = this;
			const { trackingOptions } = data; // used for analytics tracking
			const events = [];
			const page = 1; // keeps track of what page of events to request
			let { handle } = setup;

			if (!this.isString(handle, 1)) {
				throw new Error(`setup.handle is required`);
			}

			trackingOptions.pageType = `Promoter`;
			handle = handle.toLowerCase(); // important for API call, capitalized via CSS where visible
			this.assign(data, { events, page, handle, pageUrl });

			return this.when({
				promises: [Promoters.get({ handle }), this.getMoreEvents()],
				spread: (promoter) => {
					const title = `Promoter - ${handle} | Tixr`;
					this.assign(data, { promoter, title });
				},
			});
		},
		constructor(setup) {
			const { App, data, elements } = this;
			const { events } = data;
			const promises = [
				this.create({
					namespace: `Modules/PageHeader`,
					setup: {
						name: `page-header`,
						showTixrLogo: true,
					},
				}),
				this.create({
					namespace: `Modules/PageFooter`,
					setup: {
						name: `page-footer`,
					},
				}),
				this.create({
					namespace: `Modules/EventList`,
					setup: {
						name: `event-list`,
						layout: `GRID`,
						events,
					},
					then: (eventList) => {
						const { container: eventsWrapper } = eventList;
						const { length: eventCount } = events;

						elements.eventsWrapper = eventsWrapper;

						if (eventCount > 0 && eventCount % EVENTS_PER_PAGE === 0) {
							// there could be more events to fetch
							App.onScroll(this.scrollHandler);
						}
					},
				}),
			];

			return this.when({ promises });
		},

		api: {
			scrollHandler: {
				throttle: 100,
				value(evt) {
					const { App, DOM, data, elements } = this;
					const { eventsWrapper } = elements;
					const dimensions = DOM.getDimensions(eventsWrapper);
					const { viewportBottom } = dimensions;
					const adjustedBottom = viewportBottom + SCROLL_BUFFER_HEIGHT; // add the buffer

					if (adjustedBottom > 0) {
						// event list is almost above the fold
						const { events } = data;
						const { length: oldEventCount } = events;

						App.offScroll(this.scrollHandler); // remove the scroll handler

						return this.getMoreEvents({
							then: () => {
								const { length: newEventCount } = events;

								if (newEventCount > oldEventCount) {
									// event count increased
									if (newEventCount % EVENTS_PER_PAGE === 0) {
										// there could be more to fetch
										App.onScroll(this.scrollHandler); // re-add the scroll handler
									}
								}
							},
						});
					}
				},
			},
			getMoreEvents: {
				async: true,
				value() {
					const { Promoters, data, instances } = this;
					const { events, page, handle } = data;
					const eventList = instances[`event-list`];

					return Promoters.getEvents({
						handle,
						page,
						then: (newEvents) => {
							this.each(newEvents, (event) => events.push(event));
							data.page++;

							if (this.isObject(eventList)) {
								// module already exists, add the events dynamically
								eventList.addEvents({ events: newEvents });
							}
						},
					});
				},
			},
		},
	});
});

define("Pages/Promoter.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Pages/Promoter/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"pageBackgroundUrl") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":19},"end":{"line":1,"column":139}}})) != null ? stack1 : "")
    + " <header class=\"head\"> <div name=\"page-header\"></div> <div class=\"scroll-head-background\"></div> </header> <main class=\"body\"> <div class=\"content heading\"> <h1>"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"pageTitle") : depth0), depth0))
    + "</h1> <h2>"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"pageBlurb") : depth0), depth0))
    + "</h2> </div> <div class=\"content\"> <div name=\"event-list\"></div> </div> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"pageDescription") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":473},"end":{"line":1,"column":681}}})) != null ? stack1 : "")
    + " <div class=\"content footer\"> <div name=\"page-footer\"></div> </div> </main> <div class=\"foot\"></div> ";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"background\" style=\"background-image: url('"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"pageBackgroundUrl") : depth0), depth0))
    + "');\"></div> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"content centered description\"> <h2 class=\"transition-content\">Description</h2> <div class=\"transition-content description-text\"> "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"pageDescription") : depth0), depth0)) != null ? stack1 : "")
    + " </div> </div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"promoter") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":791}}})) != null ? stack1 : "");
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=Promoter.js.map